import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import * as CommonBrowserUtils from "utilities/community/common-browser-utils/1.0.0/js/common-browser-utils";
import spartaMediaQueryConstantsUtility from "utilities/global/sparta-mediaquery-constants-utility/1.1.0/js/sparta-mediaquery-constants-utility";
/**
 * Returns a browser-prefixed screen density media query where needed.
 * @return {String} The media query identifier.
 */
const getPrefixedPixelRatio = () => {
  // generate element to test vendor prefixes
  const elem = document.createElement('sparta');

  // vendor-prefixed pixel density queries
  const prefixes = {
    webkitTransform: '-webkit-min-device-pixel-ratio: 2',
    MozTransform: 'min--moz-device-pixel-ratio: 2',
    oTransform: '-o-min-device-pixel-ratio: 2/1',
  };

  // default pixel density query
  let result = 'min-device-pixel-ratio: 2';

  // iterate through prefixes and check to see if vendor-prefixed query is needed
  Object.keys(prefixes).some((prefix) => {
    // if the element contains this vendor-prefixed transform style attribute
    if (typeof elem.style[prefix] !== 'undefined') {
      // get our prefixed media query
      result = prefixes[prefix];

      // exit Array.some()
      return true;
    }

    return false;
  });

  // return necessary media query
  return result;
};

export { getPrefixedPixelRatio };
